import { render, staticRenderFns } from "./AttachmentButton.vue?vue&type=template&id=431f91f0&"
import script from "./AttachmentButton.vue?vue&type=script&lang=js&"
export * from "./AttachmentButton.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports